import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../store";

type UiState = {
  modals: {
    menu: boolean;
  };
  isLoadingPage: boolean;
};

const initialState: UiState = {
  modals: {
    menu: false,
  },
  isLoadingPage: false,
};

const uiSlice = createSlice({
  name: "ui",
  initialState,
  reducers: {
    setModal: (
      state,
      action: PayloadAction<{ modal: keyof UiState["modals"]; value: boolean }>
    ) => {
      state.modals[action.payload.modal] = action.payload.value;
    },
    setIsLoadingPage: (state, action: PayloadAction<boolean>) => {
      state.isLoadingPage = action.payload;
    },
  },
});

const { reducer, actions } = uiSlice;

export const { setModal, setIsLoadingPage } = actions;

export const selectMenuModal = (state: RootState) => state.ui.modals.menu;
export const selectIsLoadingPage = (state: RootState) => state.ui.isLoadingPage;

export default reducer;
